export const SERVICES: Record<string, {
  slug: string
  nome: string
  descrizione: string
  metaTitle: (città: string) => string
  metaDescription: (città: string) => string
  heroTitle: (città: string) => string
  heroParagraph: (città: string) => string
  cards: { titolo: string; testo: string }[]
  faq: { domanda: string; risposta: string }[]
}> = {
  'pulizie-appartamenti-vacanze': {
    slug: 'pulizie-appartamenti-vacanze',
    nome: 'Pulizia Appartamenti Vacanze',
    descrizione: 'Pulizia professionale per appartamenti vacanze e case per affitti brevi.',
    metaTitle: (città) =>
      `Impresa Pulizie Appartamenti Vacanze a ${città} | Halomora`,
    metaDescription: (città) =>
      `Cerchi un'azienda di pulizie per appartamenti vacanze a ${città}? Trova imprese verificate per cambi ospite, pulizie di fondo e preventivi gratuiti.`,
    heroTitle: (città) => `Aziende per pulizie appartamenti vacanze a ${città}`,
    heroParagraph: (città) =>
      `Trova imprese di pulizie verificate per appartamenti vacanze, case al mare e affitti brevi a ${città}. Pulizia di cambio tra ospiti, pulizia di fondo stagionale e sanificazione, con preventivi gratuiti entro 24 ore.`,
    cards: [
      { titolo: 'Pulizia di Cambio', testo: 'Pulizia rapida tra check-out e check-in successivo, cambio biancheria incluso.' },
      { titolo: 'Pulizia di Fondo', testo: 'Pulizia approfondita per apertura o chiusura stagionale dell\'appartamento.' },
      { titolo: 'Sanificazione', testo: 'Igienizzazione certificata di tutti gli ambienti.' },
      { titolo: 'Manutenzione Ordinaria', testo: 'Piccoli interventi di cura e manutenzione della proprietà.' },
    ],
    faq: [
      {
        domanda: 'Quanto costa una pulizia di cambio?',
        risposta: 'Il costo dipende dalla metratura, dal numero di letti e dal tipo di servizio. Richiedi un preventivo gratuito su Halomora per ricevere offerte da imprese di pulizie locali.',
      },
      {
        domanda: 'Posso prenotare last minute?',
        risposta: 'Sì. Molte imprese su Halomora hanno disponibilità entro 24-48 ore.',
      },
      {
        domanda: 'Le imprese sono verificate?',
        risposta: 'Halomora controlla le aziende iscritte. Ogni profilo riporta certificazioni e copertura assicurativa.',
      },
    ],
  },

  'sanificazione-attivita-commerciali': {
    slug: 'sanificazione-attivita-commerciali',
    nome: 'Sanificazione Attività Commerciali',
    descrizione: 'Sanificazione professionale certificata per negozi, uffici e attività commerciali.',
    metaTitle: (città) =>
      `Aziende Sanificazione Attività Commerciali a ${città} | Halomora`,
    metaDescription: (città) =>
      `Trova imprese per sanificazione e igienizzazione di negozi, ristoranti, uffici e attività commerciali a ${città}. Preventivi gratuiti.`,
    heroTitle: (città) => `Imprese per sanificazione attività commerciali a ${città}`,
    heroParagraph: (città) =>
      `Trova aziende di pulizie e sanificazione per la tua attività commerciale a ${città}. Interventi per negozi, ristoranti, uffici, palestre e spazi aperti al pubblico, con preventivi gratuiti entro 24 ore.`,
    cards: [
      { titolo: 'Sanificazione Negozi', testo: 'Igienizzazione completa di superfici, arredi e aree ad alto contatto.' },
      { titolo: 'Sanificazione Ristoranti', testo: 'Trattamenti conformi alle normative HACCP per cucine e sale.' },
      { titolo: 'Sanificazione Uffici', testo: 'Interventi periodici o straordinari per ambienti di lavoro.' },
      { titolo: 'Certificazione', testo: 'Rilascio documentazione di avvenuta sanificazione su richiesta.' },
    ],
    faq: [
      {
        domanda: 'La sanificazione è certificata?',
        risposta: 'Sì. Le imprese di pulizie e sanificazione su Halomora possono rilasciare documentazione di avvenuta sanificazione conforme alle normative vigenti.',
      },
      {
        domanda: 'Con quale frequenza è consigliata la sanificazione?',
        risposta: 'Dipende dal tipo di attività. Contattaci per un piano personalizzato in base alle tue esigenze specifiche.',
      },
      {
        domanda: 'Intervenite anche in urgenza?',
        risposta: 'Sì. Molte imprese partner offrono interventi urgenti entro 24 ore.',
      },
    ],
  },

  'pulizie-post-cantiere': {
    slug: 'pulizie-post-cantiere',
    nome: 'Pulizie Post-Cantiere',
    descrizione: 'Pulizia professionale dopo lavori di ristrutturazione o costruzione.',
    metaTitle: (città) =>
      `Impresa Pulizie Post-Cantiere a ${città} | Halomora`,
    metaDescription: (città) =>
      `Cerchi un'impresa per pulizie post-cantiere a ${città}? Trova aziende verificate per rimozione polvere, detriti e residui dopo lavori. Preventivo gratuito.`,
    heroTitle: (città) => `Aziende per pulizie post-cantiere a ${città}`,
    heroParagraph: (città) =>
      `Hai appena terminato una ristrutturazione a ${città}? Trova imprese di pulizie specializzate in post-cantiere per rimuovere polvere, detriti e residui da costruzione. Preventivi gratuiti entro 24 ore.`,
    cards: [
      { titolo: 'Rimozione Polvere e Detriti', testo: 'Pulizia completa di polvere fine, calcinacci e residui di lavorazione.' },
      { titolo: 'Pulizia Superfici', testo: 'Lavaggio di pavimenti, finestre, infissi e superfici dopo i lavori.' },
      { titolo: 'Smaltimento Rifiuti', testo: 'Raccolta e smaltimento corretto dei materiali di scarto.' },
      { titolo: 'Pronto Uso', testo: 'Locali restituiti puliti e pronti per essere abitati o aperti al pubblico.' },
    ],
    faq: [
      {
        domanda: 'Quanto tempo richiede una pulizia post-cantiere?',
        risposta: 'Dipende dalla metratura, dall\'entità dei lavori e dalla quantità di residui. Richiedi un preventivo gratuito per ricevere una stima da aziende di pulizie locali.',
      },
      {
        domanda: 'Gestite anche lo smaltimento dei rifiuti?',
        risposta: 'Sì. Le imprese partner gestiscono la raccolta e lo smaltimento corretto dei materiali di cantiere.',
      },
      {
        domanda: 'Operate anche nei fine settimana?',
        risposta: 'Molte imprese su Halomora sono disponibili anche nel weekend. Verifica la disponibilità al momento della richiesta.',
      },
    ],
  },

  'pulizie-uffici-aziende': {
    slug: 'pulizie-uffici-aziende',
    nome: 'Pulizie Uffici e Aziende',
    descrizione: 'Pulizia professionale per uffici, studi e spazi aziendali.',
    metaTitle: (città) =>
      `Impresa Pulizie Uffici e Aziende a ${città} | Halomora`,
    metaDescription: (città) =>
      `Trova aziende di pulizie per uffici, studi professionali e aziende a ${città}. Contratti periodici, interventi straordinari e preventivi gratuiti.`,
    heroTitle: (città) => `Aziende per pulizie uffici e aziende a ${città}`,
    heroParagraph: (città) =>
      `Mantieni uffici, studi e spazi aziendali a ${città} puliti e professionali. Trova imprese di pulizie specializzate in ambienti di lavoro, con contratti periodici o interventi su richiesta e preventivi gratuiti.`,
    cards: [
      { titolo: 'Pulizie Giornaliere', testo: 'Servizio continuativo per mantenere l\'ufficio pulito ogni giorno.' },
      { titolo: 'Pulizie Periodiche', testo: 'Interventi settimanali o mensili su misura per la tua azienda.' },
      { titolo: 'Pulizie Straordinarie', testo: 'Interventi approfonditi per eventi, traslochi o esigenze speciali.' },
      { titolo: 'Aree Comuni', testo: 'Pulizia di reception, bagni, sale riunioni e corridoi.' },
    ],
    faq: [
      {
        domanda: 'Posso stipulare un contratto periodico?',
        risposta: 'Sì. Puoi concordare un piano di pulizie ricorrente per uffici e aziende con l\'impresa scelta su Halomora.',
      },
      {
        domanda: 'Le pulizie vengono eseguite fuori orario lavorativo?',
        risposta: 'Sì. La maggior parte delle imprese opera la mattina presto o la sera per non disturbare l\'attività.',
      },
      {
        domanda: 'Operate anche nelle zone industriali?',
        risposta: 'Sì. Le imprese partner coprono sia uffici che capannoni e aree produttive.',
      },
    ],
  },

  'pulizie-supermercati-ristoranti': {
    slug: 'pulizie-supermercati-ristoranti',
    nome: 'Pulizie Supermercati e Ristoranti',
    descrizione: 'Pulizia professionale per la ristorazione, la grande distribuzione e il food retail.',
    metaTitle: (città) =>
      `Impresa Pulizie Supermercati e Ristoranti a ${città} | Halomora`,
    metaDescription: (città) =>
      `Cerchi aziende di pulizie per supermercati, ristoranti e locali food a ${città}? Imprese verificate, interventi notturni, HACCP e preventivi gratuiti.`,
    heroTitle: (città) => `Aziende per pulizie supermercati e ristoranti a ${città}`,
    heroParagraph: (città) =>
      `Trova imprese di pulizie per supermercati, ristoranti, gastronomie e locali food a ${città}. Interventi conformi alle normative HACCP, disponibilità notturna e preventivi gratuiti entro 24 ore.`,
    cards: [
      { titolo: 'Conformità HACCP', testo: 'Pulizie conformi alle normative igieniche per la ristorazione e la GDO.' },
      { titolo: 'Interventi Notturni', testo: 'Pulizie eseguite a locali chiusi per non interrompere l\'attività.' },
      { titolo: 'Cucine Professionali', testo: 'Sgrassaggio profondo di cappe, forni, griglie e superfici di lavoro.' },
      { titolo: 'Pavimenti e Aree di Vendita', testo: 'Lavaggio e lucidatura di pavimenti in ambienti ad alto traffico.' },
    ],
    faq: [
      {
        domanda: 'Le pulizie sono conformi alle normative HACCP?',
        risposta: 'Sì. Le imprese di pulizie partner su Halomora operano in conformità con le normative igienico-sanitarie vigenti per ristorazione e ambienti food.',
      },
      {
        domanda: 'Intervenite di notte o nei giorni di chiusura?',
        risposta: 'Sì. Molte imprese offrono disponibilità notturna e nel giorno di chiusura settimanale.',
      },
      {
        domanda: 'Gestite anche la pulizia delle celle frigorifere?',
        risposta: 'Sì. Su richiesta è possibile includere la pulizia e la sanificazione delle celle frigorifere.',
      },
    ],
  },

  'pulizie-enti-pubblici': {
    slug: 'pulizie-enti-pubblici',
    nome: 'Pulizie per Enti Pubblici',
    descrizione: 'Pulizia professionale per scuole, ospedali, uffici pubblici e strutture istituzionali.',
    metaTitle: (città) =>
      `Impresa Pulizie Enti Pubblici a ${città} | Halomora`,
    metaDescription: (città) =>
      `Trova aziende di pulizie per enti pubblici a ${città}: scuole, uffici comunali, biblioteche, strutture sanitarie e spazi istituzionali. Preventivi gratuiti.`,
    heroTitle: (città) => `Aziende per pulizie enti pubblici a ${città}`,
    heroParagraph: (città) =>
      `Trova imprese specializzate nella pulizia di enti pubblici a ${città}. Scuole, biblioteche, uffici comunali, strutture sanitarie e spazi istituzionali con standard professionali e preventivi gratuiti.`,
    cards: [
      { titolo: 'Scuole e Istituti', testo: 'Pulizie giornaliere e straordinarie per ambienti scolastici.' },
      { titolo: 'Strutture Sanitarie', testo: 'Sanificazione e pulizia per ambulatori, poliambulatori e strutture ospedaliere.' },
      { titolo: 'Uffici Comunali', testo: 'Pulizie per municipali, biblioteche e strutture istituzionali.' },
      { titolo: 'Aree Esterne', testo: 'Pulizia di cortili, parcheggi e spazi esterni delle strutture pubbliche.' },
    ],
    faq: [
      {
        domanda: 'Le imprese sono in regola per operare in strutture pubbliche?',
        risposta: 'Sì. Le imprese di pulizie partner su Halomora possono indicare certificazioni, requisiti e coperture richieste per operare in strutture pubbliche.',
      },
      {
        domanda: 'Gestite anche le gare d\'appalto?',
        risposta: 'Contatta direttamente le imprese sul profilo Halomora per valutare la partecipazione a procedure di appalto pubblico.',
      },
      {
        domanda: 'Operate anche in strutture sanitarie?',
        risposta: 'Sì. Alcune imprese partner sono specializzate nella sanificazione di ambulatori e strutture sanitarie.',
      },
    ],
  },
}

export const CITIES: Record<string, {
  slug: string
  nome: string
  nomeEsteso: string
  zoneVicine: string
  contestoLocale: string
  specificita: string
}> = {
  jesolo: {
    slug: 'jesolo',
    nome: 'Jesolo',
    nomeEsteso: 'Jesolo',
    zoneVicine: 'Jesolo Lido, Jesolo Paese, Cavallino-Treporti, Eraclea, San Donà di Piave',
    contestoLocale: "centinaia di appartamenti vacanze, hotel, residence e attività commerciali distribuiti tra Jesolo Lido, Jesolo Paese e la zona Pineta",
    specificita: "I picchi di affluenza tra luglio e agosto richiedono squadre con turni serrati e disponibilità nei weekend, mentre fuori stagione il ritmo si distende",
  },
  cavallino: {
    slug: 'cavallino',
    nome: 'Cavallino',
    nomeEsteso: 'Cavallino-Treporti',
    zoneVicine: 'Cavallino-Treporti, Jesolo, Venezia Lido, Punta Sabbioni',
    contestoLocale: "la penisola tra laguna nord di Venezia e Adriatico, con grandi campeggi, villaggi turistici e case private fra Punta Sabbioni e Cavallino centro",
    specificita: "La stagione lunga da Pasqua a fine settembre e la posizione decentrata richiedono squadre con buona autonomia di spostamento e orari coordinati al ferry per Venezia",
  },
  caorle: {
    slug: 'caorle',
    nome: 'Caorle',
    nomeEsteso: 'Caorle',
    zoneVicine: 'Caorle, Bibione, Porto Santa Margherita, San Stino di Livenza',
    contestoLocale: "il borgo storico con le case colorate, il campanile cilindrico e le zone balneari di Levante, Ponente, Porto Santa Margherita e Duna Verde",
    specificita: "Il centro storico ha accessi limitati per i mezzi pesanti, quindi gli interventi sono pianificati in fasce orarie dedicate per carico e scarico",
  },
  venezia: {
    slug: 'venezia',
    nome: 'Venezia',
    nomeEsteso: 'Venezia',
    zoneVicine: 'Venezia, Mestre, Marghera, Lido di Venezia, Murano, Burano',
    contestoLocale: "il centro storico distribuito sui sei sestieri, le isole di Murano, Burano e Giudecca e la terraferma di Mestre e Marghera",
    specificita: "La logistica passa per barche da trasporto e portage a mano in centro storico, mentre in terraferma si opera con furgoni e accessi ZTL ordinari",
  },
  bibione: {
    slug: 'bibione',
    nome: 'Bibione',
    nomeEsteso: 'Bibione',
    zoneVicine: 'Bibione, Caorle, Lignano Sabbiadoro, San Michele al Tagliamento',
    contestoLocale: "la grande area pedonale fronte mare, il porticciolo, la pineta e le zone di Bibione Lido dei Pini e Bibione Pineda",
    specificita: "L'accesso ai mezzi nell'area pedonale è consentito in finestre orarie specifiche, di solito tra le 6 e le 9 del mattino, e va pianificato con anticipo",
  },
  eraclea: {
    slug: 'eraclea',
    nome: 'Eraclea',
    nomeEsteso: 'Eraclea',
    zoneVicine: 'Eraclea Mare, Jesolo, Caorle, Torre di Fine',
    contestoLocale: "Eraclea Mare con la pineta protetta, il capoluogo comunale e le frazioni residenziali interne",
    specificita: "Le distanze contenute e il traffico moderato permettono interventi puntuali in fasce orarie ampie, anche fuori stagione",
  },
}
